class WDNCartGifts extends HTMLElement {
  // Master elements will mirror HTML towards Subs
  constructor() {
    super();
  }

  findAllSubs() {
    if (!this.subs) {
      this.subs = Array.from(document.querySelectorAll('wdn-cart-gifts')).filter((elem) => {
        return !elem.hasAttribute('data-master');
      });
    };
  }

  mirrorToSubs() {
    this.findAllSubs();
    let masterDOM = this.innerHTML;
    
    if (this.subs && this.subs.length > 0) {
      this.subs.forEach(sub => {
        if (sub.mirrorFromMaster) {
          sub.mirrorFromMaster(masterDOM);
        }
      });
    }
  }

  mirrorFromMaster(masterDOM) {
    this.innerHTML = masterDOM;
  }

  connectedCallback() {
    if (this.hasAttribute('data-master')) {
      this.mirrorToSubs(); 
    } else {
      const otherMaster = document.querySelector("wdn-cart-gifts[data-master]");
      if (otherMaster) {
        this.mirrorFromMaster(otherMaster.innerHTML);
      }
    }
  }
}

class WDNCartGiftItem extends HTMLElement {
  constructor() {
    super();

    this.WDNCart = document.querySelector('wdn-cart');
    this.initialSubmitButton = this.querySelector('button[data-name="gift_update"]');
  }

  updateCart() {
    if (!this.WDNCart) {
      this.WDNCart = document.querySelector('wdn-cart');
    }

    if (this.WDNCart) {
      this.WDNCart.reloadCart();
    }
  }

  
  removeFromCart() {
    let _updates = {
      quantity: 0
    };
    
    _updates["id"] = this.lineId;

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(_updates)
    })
    .then(response => {
      this.updateCart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  addToCart() {
    var itemId = this.lineId;
    let formData = {
     'items': [{
      'id': itemId,
      'quantity': 1,
       'properties': {
         "_isFreeGift": "yes"
       }
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
    })
    .then(response => {
      this.updateCart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }


  onGiftClick() {
    if (this.giftStatus == 'unlocked') {
      this.addToCart();
    }
  }

  init() {
    this.submitBtn = this.querySelector('button[data-name="gift_update"]');
    this.lineId = this.getAttribute('data-line-id');
    this.giftStatus = this.getAttribute('data-gift-status');

    if (this.closest("wdn-cart-gifts").hasAttribute('data-master')) {
      if (this.giftStatus == 'invalid') {
        this.removeFromCart();
      }
    }

    this.submitBtn.addEventListener('click', this.onGiftClick.bind(this));
  }

  connectedCallback() {
    this.init();
  }
}

customElements.define('wdn-cart-gifts', WDNCartGifts);
customElements.define('wdn-gift-item', WDNCartGiftItem);
